import { defineNuxtPlugin, useHead, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin({
  name: "plausible:preconnect",
  setup() {
    const { plausible: options } = useRuntimeConfig().public;
    if (options.enabled && options.apiHost) {
      useHead({
        link: [
          {
            rel: "preconnect",
            href: options.apiHost
          }
        ]
      });
    }
  }
});
